import { api } from "../api";

export const deleteCareTemplate = async (id: string) => {
  await api.services.careTemplates.deleteCareTemplate(id);
};
